import { useState } from "react";
import PageContainer from "../components/layout/PageContainer";
import TopUpForm from "../components/billing/TopUpForm";
import BalanceCard from "../components/billing/BalanceCard";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { useApi } from "../hooks/useApi";
import { billingApi } from "../api/billing";

export default function TopUp() {
  const balance = useApi(() => billingApi.getBalance(), []);
  const [submitting, setSubmitting] = useState(false);

  async function handleTopUp(amountPence: number) {
    setSubmitting(true);
    try {
      const result = await billingApi.topUp(amountPence);
      // Redirect to Stripe Checkout
      if (result.data?.url) {
        window.location.href = result.data.url;
      }
    } finally {
      setSubmitting(false);
    }
  }

  if (balance.loading) {
    return <LoadingSpinner message="Loading account..." />;
  }

  const balanceData = balance.data?.data;

  return (
    <PageContainer
      title="Top Up"
      description="Add credit to your account"
    >
      <div className="mx-auto max-w-xl space-y-6">
        {/* Current balance */}
        {balanceData && (
          <BalanceCard
            balance={balanceData.balance}
            currency={balanceData.currency}
            alertThreshold={balanceData.alertThreshold}
          />
        )}

        {/* Top-up form */}
        <div className="rounded-lg border border-gray-200 bg-white p-6">
          <h2 className="mb-4 text-lg font-medium text-gray-900">
            Choose amount
          </h2>
          <TopUpForm onSubmit={handleTopUp} loading={submitting} />
        </div>

        {/* Info */}
        <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
          <p className="text-sm text-blue-700">
            Payments are processed securely by Stripe. Your credit will be
            added to your account automatically after payment.
          </p>
        </div>
      </div>
    </PageContainer>
  );
}
